import React, { createContext, useContext, useEffect, useState } from "react";

const dict = {
  id: {
    // nav
    nav_features: "Fitur",
    nav_about: "Tentang",
    nav_login: "Masuk",
    nav_register: "Daftar",
    nav_logout: "Keluar",
    // landing
    hero_kicker: "Asisten Kesehatan AI Personal",
    hero_title: "Hidup lebih sehat, dengan pendamping yang benar-benar memahamimu.",
    hero_sub: "Gracely mengenal profil medismu, menyusun jadwal olahraga adaptif, dan mengingatkan bahan makanan yang tidak cocok untukmu — semua dalam satu tempat yang tenang.",
    hero_cta_primary: "Mulai Gratis",
    hero_cta_secondary: "Pelajari Lebih Lanjut",
    features_title: "Semua yang kamu butuhkan untuk pemulihan & kebugaran",
    f1_title: "Anamnesis Digital",
    f1_desc: "Simpan kondisi medis, alergi, dan aktivitas untuk rekomendasi yang benar-benar personal.",
    f2_title: "Jadwal Olahraga Adaptif",
    f2_desc: "Rutinitas low-impact untuk pemulihan, atau program kebugaran untuk stamina.",
    f3_title: "Analisis Label Makanan",
    f3_desc: "Foto atau tempel label — Gracely tandai bahan berbahaya berdasarkan profilmu.",
    f4_title: "Chat Empati dengan Gracely",
    f4_desc: "Panduan yang hangat dan bersandar pada literatur medis. Bukan diagnosis.",
    f5_title: "Prediksi & Kebiasaan",
    f5_desc: "Lihat konsistensimu dan potensi kesehatan jangka panjang.",
    footer_note: "Dibuat dengan empati oleh tim Healthy Gracely.",
    // auth
    login_title: "Selamat datang kembali",
    login_sub: "Masuk untuk melanjutkan perjalanan kesehatanmu.",
    register_title: "Mulai perjalanan sehatmu",
    register_sub: "Buat akun untuk personalisasi Gracely.",
    email: "Email",
    password: "Kata sandi",
    name: "Nama",
    submit_login: "Masuk",
    submit_register: "Daftar sekarang",
    have_account: "Sudah punya akun?",
    no_account: "Belum punya akun?",
    // onboarding
    onboard_title: "Kenali dirimu",
    onboard_sub: "Bantu Gracely memahami kondisi kesehatanmu.",
    step: "Langkah",
    of: "dari",
    conditions_label: "Kondisi medis (bisa lebih dari satu)",
    healthy: "Sehat / Normal",
    hypertension: "Hipertensi",
    diabetes: "Diabetes",
    gastritis: "Gastritis",
    other: "Lainnya",
    conditions_other_label: "Sebutkan kondisi lain (langka atau spesifik)",
    conditions_other_placeholder: "Misal: Sindrom Ehlers-Danlos, POTS, Lupus…",
    conditions_other_help: "Gracely akan mempertimbangkan kondisi ini dalam setiap saran.",
    age: "Usia",
    birthdate: "Tanggal lahir",
    birthdate_required: "Silakan isi tanggal lahir terlebih dahulu.",
    age_label: "Usia",
    years_old: "tahun",
    weight: "Berat (kg)",
    height: "Tinggi (cm)",
    allergies: "Alergi (pisahkan dengan koma)",
    activity_level: "Tingkat aktivitas",
    sedentary: "Jarang bergerak",
    light: "Ringan",
    moderate: "Sedang",
    active: "Aktif",
    very_active: "Sangat aktif",
    recovery_mode: "Sedang dalam masa pemulihan",
    notes: "Catatan tambahan (opsional)",
    save_profile: "Simpan profil",
    next: "Lanjut",
    back: "Kembali",
    // dashboard
    dash_welcome: "Halo",
    dash_today: "Rencana hari ini",
    dash_streak: "Streak konsistensi",
    dash_alerts: "Peringatan nutrisi",
    dash_no_workout: "Belum ada rencana. Buat jadwal olahragamu.",
    generate_plan: "Buat jadwal olahraga",
    // chat_title
    chat_title: "Percakapan dengan Gracely",
    chat_placeholder: "Tulis pertanyaanmu untuk Gracely…",
    send: "Kirim",
    thinking: "Gracely sedang berpikir…",
    // workouts
    workouts_title: "Jadwal Olahraga",
    mark_done: "Tandai selesai",
    marked_done: "Sudah selesai",
    // food
    food_title: "Pindai Label Makanan",
    tab_text: "Tempel Teks",
    tab_image: "Unggah Foto",
    scan_btn: "Analisis sekarang",
    scanning: "Menganalisis…",
    verdict_safe: "Aman untukmu",
    verdict_caution: "Perlu perhatian",
    verdict_danger: "Berbahaya",
    // habits
    habits_title: "Kebiasaan & Prediksi",
    water: "Air (gelas)",
    steps: "Langkah",
    sleep: "Tidur (jam)",
    mood: "Mood (1-5)",
    ate_healthy: "Makan sehat hari ini",
    save_log: "Simpan log",
    get_insight: "Dapatkan wawasan dari Gracely",
    // profile
    profile_title: "Profil Kesehatan",
    edit: "Edit",
  },
  en: {
    nav_features: "Features",
    nav_about: "About",
    nav_login: "Log in",
    nav_register: "Sign up",
    nav_logout: "Log out",
    hero_kicker: "Personal AI Health Companion",
    hero_title: "Live healthier with a companion that truly understands you.",
    hero_sub: "Gracely learns your medical profile, builds adaptive workouts, and flags food ingredients that don't fit you — all in one calm space.",
    hero_cta_primary: "Start free",
    hero_cta_secondary: "Learn more",
    features_title: "Everything you need for recovery & wellness",
    f1_title: "Digital Anamnesis",
    f1_desc: "Store medical conditions, allergies, and activity for truly personalized guidance.",
    f2_title: "Adaptive Workouts",
    f2_desc: "Low-impact routines for recovery, or fitness programs for stamina.",
    f3_title: "Food Label Analyzer",
    f3_desc: "Snap or paste a label — Gracely flags harmful ingredients based on your profile.",
    f4_title: "Empathetic Chat",
    f4_desc: "Warm guidance grounded in medical literature. Never a diagnosis.",
    f5_title: "Predictions & Habits",
    f5_desc: "See consistency and your long-term health potential.",
    footer_note: "Crafted with empathy by the Healthy Gracely team.",
    login_title: "Welcome back",
    login_sub: "Sign in to continue your health journey.",
    register_title: "Begin your health journey",
    register_sub: "Create an account to personalize Gracely.",
    email: "Email",
    password: "Password",
    name: "Name",
    submit_login: "Sign in",
    submit_register: "Create account",
    have_account: "Already have an account?",
    no_account: "Don't have an account?",
    onboard_title: "Get to know you",
    onboard_sub: "Help Gracely understand your health.",
    step: "Step",
    of: "of",
    conditions_label: "Medical conditions (choose any)",
    healthy: "Healthy / Normal",
    hypertension: "Hypertension",
    diabetes: "Diabetes",
    gastritis: "Gastritis",
    other: "Other",
    conditions_other_label: "Describe other conditions (rare or specific)",
    conditions_other_placeholder: "e.g. Ehlers-Danlos syndrome, POTS, Lupus…",
    conditions_other_help: "Gracely will factor these into every suggestion.",
    age: "Age",
    birthdate: "Date of birth",
    birthdate_required: "Please enter your date of birth first.",
    age_label: "Age",
    years_old: "years old",
    weight: "Weight (kg)",
    height: "Height (cm)",
    allergies: "Allergies (comma-separated)",
    activity_level: "Activity level",
    sedentary: "Sedentary",
    light: "Light",
    moderate: "Moderate",
    active: "Active",
    very_active: "Very active",
    recovery_mode: "Currently in recovery",
    notes: "Additional notes (optional)",
    save_profile: "Save profile",
    next: "Next",
    back: "Back",
    dash_welcome: "Hi",
    dash_today: "Today's plan",
    dash_streak: "Consistency streak",
    dash_alerts: "Nutrition alerts",
    dash_no_workout: "No plan yet. Generate your workouts.",
    generate_plan: "Generate workout plan",
    chat_title: "Conversation with Gracely",
    chat_placeholder: "Ask Gracely anything…",
    send: "Send",
    thinking: "Gracely is thinking…",
    workouts_title: "Workout Schedule",
    mark_done: "Mark done",
    marked_done: "Completed",
    food_title: "Scan food label",
    tab_text: "Paste text",
    tab_image: "Upload image",
    scan_btn: "Analyze",
    scanning: "Analyzing…",
    verdict_safe: "Safe for you",
    verdict_caution: "Needs caution",
    verdict_danger: "Harmful",
    habits_title: "Habits & Insights",
    water: "Water (glasses)",
    steps: "Steps",
    sleep: "Sleep (hrs)",
    mood: "Mood (1-5)",
    ate_healthy: "Ate healthy today",
    save_log: "Save log",
    get_insight: "Get Gracely's insight",
    profile_title: "Health Profile",
    edit: "Edit",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("gracely_lang") || "id");
  useEffect(() => {
    localStorage.setItem("gracely_lang", lang);
  }, [lang]);
  const t = (k) => dict[lang][k] || dict.en[k] || k;
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
